import React from 'react';
import { About, Footer, Header, Services, Skills, Work } from '../container';
import { Navbar } from '../Components';
import './App.scss'

const App = () => {
  return (
    <div className="app">
      <Navbar />
       <Header />
       <About />
       <Work />
       <Skills />
       <Services />
       <Footer />
    </div>
  )
}

export default App